// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Toastify__toast-body {
    max-height: 250px !important;
    overflow-y: auto !important;
}

.Toastify__toast-body::-webkit-scrollbar {
    display: none;
}

::-webkit-scrollbar {
    width: 7px;
    height: 5px;
  }

  ::-webkit-scrollbar-thumb {
    background: #BDBDBD;
    cursor: pointer;
    border-radius: 2.5px;
  }

  ::-webkit-scrollbar-track {
    background: #F8F8F8;
    border-radius: 2.5px;
  }

  .ck-editor__editable {
    min-height: 124px;
    max-height: 250px;
}

.ck.ck-balloon-panel.ck-balloon-panel_visible{
    display: none !important;
}

.ck.ck-editor__main>.ck-editor__editable:not(.ck-focused){
  border-color: #BDBDBD;
  min-height: 124px !important;
}

.ck-rounded-corners .ck.ck-editor__main>.ck-editor__editable, .ck.ck-editor__main>.ck-editor__editable.ck-rounded-corners{
  border-radius: 0px 0px 4px 4px;
}

.ck.ck-editor__top .ck-sticky-panel .ck-sticky-panel__content{
  border-color: #BDBDBD;
  border-radius: 0px 0px 4px 4px;
}
.ck.ck-editor__editable.ck-focused:not(.ck-editor__nested-editable){
  border-color: #BDBDBD;
  box-shadow: none;
  color: #005c87;
}

.ck .ck-editor__main{
  color: #005c87;
  font-family: Lato;

}

.ck-placeholder{
  color: rgba(0, 92, 135, 0.30) !important;
font-family: Lato;
font-size: 16px;
font-style: normal;
font-weight: 400;
line-height: 20px; 
}

.ck .ck-placeholder:before, .ck.ck-placeholder:before{
  color: #BDBDBD !important;
font-family: Lato;
font-size: 16px;
font-style: normal;
font-weight: 400;
line-height: 20px; 
}

.ck-read-only{
  color: rgba(0, 122, 177, 0.30)!important;
}


.global-title{
  color: rgb(0, 92, 135);
  font-family: Rubik-Medium;
  font-size: 18px;
  font-weight: 500;
  line-height: 24px;
}

.global-label{
  font-size: 16px;
  color: #005C87;
  line-height: 21px;
  font-family: Rubik-Regular;
  font-weight: 400;
}

.global-sub-label{
  font-size: 16px;
  color: #005C87;
  line-height: 21px;
  font-family: Rubik-Light;
  font-weight: 300;
}

.global-star{
  font-size: 18px;
  color: #F4AAA9;
}

.css-o9k5xi-MuiInputBase-root-MuiOutlinedInput-root.Mui-disabled{
  background: #EFEFEF;
}

`, "",{"version":3,"sources":["webpack://./src/css/app.css"],"names":[],"mappings":"AAAA;IACI,4BAA4B;IAC5B,2BAA2B;AAC/B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,UAAU;IACV,WAAW;EACb;;EAEA;IACE,mBAAmB;IACnB,eAAe;IACf,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;EACE,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,qBAAqB;EACrB,8BAA8B;AAChC;AACA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;;AAEnB;;AAEA;EACE,wCAAwC;AAC1C,iBAAiB;AACjB,eAAe;AACf,kBAAkB;AAClB,gBAAgB;AAChB,iBAAiB;AACjB;;AAEA;EACE,yBAAyB;AAC3B,iBAAiB;AACjB,eAAe;AACf,kBAAkB;AAClB,gBAAgB;AAChB,iBAAiB;AACjB;;AAEA;EACE,wCAAwC;AAC1C;;;AAGA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":[".Toastify__toast-body {\n    max-height: 250px !important;\n    overflow-y: auto !important;\n}\n\n.Toastify__toast-body::-webkit-scrollbar {\n    display: none;\n}\n\n::-webkit-scrollbar {\n    width: 7px;\n    height: 5px;\n  }\n\n  ::-webkit-scrollbar-thumb {\n    background: #BDBDBD;\n    cursor: pointer;\n    border-radius: 2.5px;\n  }\n\n  ::-webkit-scrollbar-track {\n    background: #F8F8F8;\n    border-radius: 2.5px;\n  }\n\n  .ck-editor__editable {\n    min-height: 124px;\n    max-height: 250px;\n}\n\n.ck.ck-balloon-panel.ck-balloon-panel_visible{\n    display: none !important;\n}\n\n.ck.ck-editor__main>.ck-editor__editable:not(.ck-focused){\n  border-color: #BDBDBD;\n  min-height: 124px !important;\n}\n\n.ck-rounded-corners .ck.ck-editor__main>.ck-editor__editable, .ck.ck-editor__main>.ck-editor__editable.ck-rounded-corners{\n  border-radius: 0px 0px 4px 4px;\n}\n\n.ck.ck-editor__top .ck-sticky-panel .ck-sticky-panel__content{\n  border-color: #BDBDBD;\n  border-radius: 0px 0px 4px 4px;\n}\n.ck.ck-editor__editable.ck-focused:not(.ck-editor__nested-editable){\n  border-color: #BDBDBD;\n  box-shadow: none;\n  color: #005c87;\n}\n\n.ck .ck-editor__main{\n  color: #005c87;\n  font-family: Lato;\n\n}\n\n.ck-placeholder{\n  color: rgba(0, 92, 135, 0.30) !important;\nfont-family: Lato;\nfont-size: 16px;\nfont-style: normal;\nfont-weight: 400;\nline-height: 20px; \n}\n\n.ck .ck-placeholder:before, .ck.ck-placeholder:before{\n  color: #BDBDBD !important;\nfont-family: Lato;\nfont-size: 16px;\nfont-style: normal;\nfont-weight: 400;\nline-height: 20px; \n}\n\n.ck-read-only{\n  color: rgba(0, 122, 177, 0.30)!important;\n}\n\n\n.global-title{\n  color: rgb(0, 92, 135);\n  font-family: Rubik-Medium;\n  font-size: 18px;\n  font-weight: 500;\n  line-height: 24px;\n}\n\n.global-label{\n  font-size: 16px;\n  color: #005C87;\n  line-height: 21px;\n  font-family: Rubik-Regular;\n  font-weight: 400;\n}\n\n.global-sub-label{\n  font-size: 16px;\n  color: #005C87;\n  line-height: 21px;\n  font-family: Rubik-Light;\n  font-weight: 300;\n}\n\n.global-star{\n  font-size: 18px;\n  color: #F4AAA9;\n}\n\n.css-o9k5xi-MuiInputBase-root-MuiOutlinedInput-root.Mui-disabled{\n  background: #EFEFEF;\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
